
const getters = {
  payments: (state, getters) => _.get(getters.orderData, 'payments', []),
  payment: (state, getters) => _.get(getters.orderData, 'payment', {})
}

export default {
  getters
}
